import { Box, IconButton, useTheme } from '@mui/material';
import FormField from '../form-field/form-field.component';
import SelectField from '../select-field/select-field.component';
import { Delete } from '@mui/icons-material';

const genderOptions = ['Masculino', 'Feminino'];

const PassengerForm = ({
  id,
  passenger,
  onChange,
  onRemove,
  onBirthDateChange,
}) => {
  const { fullName, cpf, birthDate, email, phone, gender, errors } = passenger;

  const handleRemovePassengerClick = () => {
    onRemove(passenger);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    const newPassenger = { ...passenger, [name]: value };
    onChange(id, newPassenger);
  };

  const handleBirthDateChange = () => {
    onBirthDateChange();
  };

  const getErrorMessage = (fieldName) => {
    console.log(errors);
    return !!errors ? errors[fieldName] : null;
  };

  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', gap: '1rem' }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
          },
          columnGap: 2,
          rowGap: { xs: 4, md: 4 },
          flex: 1,
        }}
      >
        <FormField
          label="Nome completo"
          name="fullName"
          variant="light"
          required
          onChange={handleChange}
          value={fullName}
          errorMessage={getErrorMessage('fullName')}
        />
        <FormField
          label="CPF"
          name="cpf"
          variant="light"
          required
          onChange={handleChange}
          value={cpf}
          mask="999.999.999-99"
          errorMessage={getErrorMessage('cpf')}
        />
        <SelectField
          label="Sexo"
          type="text"
          name="gender"
          variant="light grey"
          required
          onChange={handleChange}
          value={gender}
          options={genderOptions}
          errorMessage={getErrorMessage('gender')}
        />
        <FormField
          label="Data de nascimento"
          name="birthDate"
          variant="light"
          required
          onChange={handleChange}
          onBlur={handleBirthDateChange}
          value={birthDate}
          mask="99/99/9999"
          errorMessage={getErrorMessage('birthDate')}
        />
        <FormField
          label="E-mail"
          name="email"
          variant="light"
          required
          onChange={handleChange}
          value={email}
          errorMessage={getErrorMessage('email')}
        />
        <FormField
          label="Telefone/Whatsapp"
          name="phone"
          variant="light"
          required
          onChange={handleChange}
          value={phone}
          mask="(99) 99999-9999"
          errorMessage={getErrorMessage('phone')}
        />
      </Box>
      <IconButton
        variant="contained"
        onClick={handleRemovePassengerClick}
        sx={{
          color: `${theme.palette.grey[50]}`,
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: 'transparent',
            '& .MuiSvgIcon-root': {
              color: 'red',
            },
          },
          '& .MuiSvgIcon-root': {
            transition: 'color 0.3s ease',
          },
        }}
      >
        <Delete />
      </IconButton>
    </Box>
  );
};

export default PassengerForm;
